// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.group-members[data-v-99cf0fe6] {\n  font-size: 14px;\n  float: right;\n}\n", ""]);
// Exports
module.exports = exports;
